/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `in` - in
 */
export type HeightUnitEnum = typeof HeightUnitEnum[keyof typeof HeightUnitEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeightUnitEnum = {
  in: 'in',
} as const;
